import React, { useEffect, useRef, useState } from 'react'
import { Button, Col, Form, Input, notification, Row } from 'antd'
import { useDispatch } from 'react-redux'
import {
  // listAllAgentsMarginActivity,
  singleAgentXTravelMarginFxn,
  updateAgentXTravelMarginFxn
} from '../actions'
import { displayDate, displayTime, InputBox } from '../../../components/_utils/appUtils'
import AgentTypeheadComponent from '../../../components/_utils/AgentTypeheadComponent'
// import { TableComp } from 'sz-react-utils-lite'
// import lodash from 'lodash'

const UpdateXTravelWorldMargin = (props) => {
  const { user } = props
  const dispatch = useDispatch()
  const [agentXTravelMargin, setAgentXTravelMargin] = useState(0.0)
  const [agentId, setAgentId] = useState(0.0)
  const tableAppRef = useRef()

  const fetchAgentMargin = async () => {
    const data = await dispatch(singleAgentXTravelMarginFxn({ userId: agentId }))
    if (data) {
      setAgentXTravelMargin(data.agentXTravelMargin)
    }
  }

  const handleSubmit = async () => {
    if (!agentId) {
      notification.error({ message: 'Please choose agent.' })
      return
    }
    if (!agentXTravelMargin) {
      notification.error({ message: 'Enter XTravelWorld margin.' })
      return
    }

    if (agentXTravelMargin > 20) {
      notification.error({ message: 'Enter Valid XTravelWorld margin.' })
      return
    }
    const payload = {
      userId: agentId,
      agentXTravelMargin
    }

    const resp = await dispatch(updateAgentXTravelMarginFxn(payload))
    if (resp.success) {
      notification.success({ message: 'Agent XTravelWorld margin updated successfully!' })
    } else {
      notification.error({ message: resp.message })
    }
  }

  useEffect(() => {
    fetchAgentMargin()
  }, [agentId])

  // let apiRequest = params => {
  //   return new Promise(async resolve => {
  //     params = { ...params }
  //     if (!params.results) {
  //       params.results = 50
  //       params.count = 50
  //     }
  //     if (agentId) {
  //       params.agentId = agentId
  //     }
  //     try {
  //       console.log(params, 'params')
  //       let resp = await dispatch(listAllAgentsMarginActivity({
  //         ...params, regExFilters: ['name']
  //       }))
  //       resolve(resp)
  //     } catch (e) {
  //     }
  //   })
  // }

  let [pageState, setPageState] = useState({ count: 10, page: 1, groupCount: 10, groupPage: 1 })

  // const columns = [
  //   {
  //     key: '_id',
  //     title: '#',
  //     dataIndex: '_id',
  //     width: 50,
  //     render: (item, record, index) => {
  //       return (
  //         <>
  //           {pageState.count * (pageState.page - 1) + (index + 1)}
  //         </>
  //       )
  //     }
  //   },
  //   {
  //     title: 'Name',
  //     key: 'agentName',
  //     dataIndex: 'agentName',
  //     width: 150,
  //     render: (item, record) => {
  //       return (item)
  //     }
  //   },
  //   {
  //     title: 'Company Name',
  //     key: 'agentCompanyName',
  //     dataIndex: 'agentCompanyName',
  //     width: 150,
  //     render: (item, record) => {
  //       return (item)
  //     }
  //   },
  //   {
  //     title: 'Transaction Type',
  //     key: 'transactionType',
  //     dataIndex: 'transactionType',
  //     width: 150,
  //     render: (item, record) => {
  //       return (item)
  //     }
  //   },
  //   {
  //     title: 'Date',
  //     key: 'date',
  //     dataIndex: 'date',
  //     width: 150,
  //     render: (item, record) => {
  //       return (
  //         <>
  //           {displayDate(item)}, {displayTime(item)}
  //         </>
  //       )
  //     }
  //   },
  //   {
  //     title: 'Amount',
  //     width: 150,
  //     dataIndex: 'amount',
  //     key: 'amount',
  //     render: (item, record) => {
  //       return (
  //         <>
  //           Rs. {item}
  //         </>
  //       )
  //     }
  //   }
  // ]

  {/*const loadColumns = () => {*/}
  //   let columnArr = []
  //   lodash.each(columns, item => {
  //     if (item.hidden == undefined) {
  {/*      columnArr.push(item)*/}
  //     } else {
  //       if (!item.hidden) {
  //         columnArr.push(item)
  //       }
  //     }
  //   })
  //   return columnArr
  // }

  return (
    <div className='row'>
      <div className='col-lg-12'>
        <Form>
          <div className='form-box mt-4'>
            <div className='d-flex align-items-center mb-3 heading-form'>
              <h5>Update XTravelWorld Margin</h5>
            </div>

            <div className='card unizportal'>
              <Row gutter={24}>
                <Col span={8}>
                  <InputBox title={'Choose Agent'}>
                    <div className='sort-box-table custom-sort-box-new'>
                      <AgentTypeheadComponent
                        customStyle={''}
                        key={agentId}
                        agentId={agentId}
                        dispatch={dispatch}
                        onSelect={item => {
                          setAgentId(item)
                        }}
                      />
                    </div>
                  </InputBox>
                </Col>
                <Col span={6}>
                  <InputBox title={'XTravelWorld Margin(in %)'}>
                    <Input
                      type={'number'}
                      value={agentXTravelMargin}
                      className={'form-control'}
                      placeholder='Enter forex margin'
                      addonAfter='%'
                      onChange={(e) => setAgentXTravelMargin(e.target.value)}
                    />
                  </InputBox>
                  {/*<div className='margin-in-words ml10'>
                    {agentXTravelMargin !== undefined ? (
                      <p><span>Amount In Words : </span>
                        <b>{numberToWords(parseFloat(agentXTravelMargin))}</b></p>
                    ) : null}
                  </div>*/}
                </Col>
              </Row>

              <Form.Item>
                <Button type='primary' htmlType='submit' className='btn' onClick={() => {
                  handleSubmit()
                }}>
                  Update
                </Button>
              </Form.Item>
            </div>
            {/*
            {agentId &&
            <div className='col-lg-12'>
              <div className='form-box mt-4'>
                <div className='d-flex align-items-center mb-3 heading-form'>
                  <h5>Agent Activity</h5>
                </div>
                <div className='card unizportal'>
                  <div className='card-body table-responsive'>
                    <TableComp
                      columns={loadColumns()}
                      rowKey={(item, index) => {
                        return index
                      }}
                      apiRequest={apiRequest}
                      pagination={{
                        position: 'top',
                        showSizeChanger: true,
                        pageSizeOptions: ['10', '20', '30', '50'],
                        defaultPageSize: 10
                      }}
                      ref={tableAppRef}
                    />
                  </div>
                </div>
              </div>
            </div>
            }
*/}
          </div>
        </Form>
      </div>
    </div>
  )
}

export default UpdateXTravelWorldMargin
